import { SelectProps } from 'antd';
import CommonService from '../Services/CommonService';


// export const getTimeZones = () => {
//   const moment = require('moment-timezone');
//   return moment.tz.names();

// }
// export const getTimeZonesOptions = () => {
//   const timeZoneOptions: SelectProps['options'] = [];
//   var timeZones = getTimeZones();
//   const moment = require('moment-timezone');
//   timeZones.map((timezone: any) => {
//     const currentTimezone = moment.tz(timezone);
//     const offsetString = currentTimezone.format('Z');
//     timeZoneOptions.push({
//       label: `(${offsetString}) ${timezone}`,
//       value: timezone,
//     });
//     return `(${offsetString}) ${timezone}`;
//   })
//   return timeZoneOptions;
// }
export const getCountries = async () => {
  let res = await CommonService.getCountriesList();
  return res;
}
export const getEnumName = (enumValue: number, enumType: any) => {
  const keys = Object.keys(enumType).filter((key) => isNaN(Number(key)));
  for (const key of keys) {
    if (enumType[key] === enumValue) {
      return key;
    }
  }
}

export enum DBRecordStatus {
  Active = 0,
  Deleted = 1,
  MarkAsDeleted = 2,
  Archived = 3
}

export const DBRecordStatusOptions = [
  { label: 'Active', value: DBRecordStatus.Active },
  { label: 'Deleted', value: DBRecordStatus.Deleted },
  { label: 'Mark As Deleted', value: DBRecordStatus.MarkAsDeleted },
  { label: 'Archived', value: DBRecordStatus.Archived },
];

export const SubmissionHoldStatusOptions = [
  { label: 'Active', value: DBRecordStatus.Active },
  { label: 'Deleted', value: DBRecordStatus.Deleted },
];

export enum ApplicationUserStatus {
  Active,
  Inactive,
  Deleted,
  Invited
}

export const ApplicationUserStatusOptions = [
  { label: 'Active', value: ApplicationUserStatus.Active },
  { label: 'Inactive', value: ApplicationUserStatus.Inactive },
  // { label: 'Deleted', value: ApplicationUserStatus.Deleted },
  // { label: 'Invited', value: ApplicationUserStatus.Invited },
];

export interface IPagingPagingItems {
  totalRecords: number;
  currentPage: number;
  pageSize: number;
};